{
    "KbLrzffmJSwxZnDeU5E27": {
        "key": "KbLrzffmJSwxZnDeU5E27",
        "position": {
            "x": 2,
            "y": 8,
            "z": 1
        },
        "affiliation": "good",
        "type": "zone"
    },
    "vCIwgxm-lpcpX-Egjv1Va": {
        "key": "vCIwgxm-lpcpX-Egjv1Va",
        "position": {
            "x": 1,
            "y": 8,
            "z": 1
        },
        "affiliation": "good",
        "type": "zone"
    },
    "5qRdum11uD1lHgUdq-DAX": {
        "key": "5qRdum11uD1lHgUdq-DAX",
        "position": {
            "x": 0,
            "y": 8,
            "z": 1
        },
        "affiliation": "good",
        "type": "zone"
    },
    "saul": {
        "key": "saul",
        "position": {
            "x": 2,
            "y": -1,
            "z": 1
        },
        "affiliation": "bad",
        "jobKey": "hero/cleric",
        "attackrange": 4,
        "ai": {
            "behaviors": [
                "avoiding"
            ]
        },
        "skills": [
            "restore-health"
        ]
    },
    "#B": {
        "key": "#B",
        "position": {
            "x": -1,
            "y": 4,
            "z": 1
        },
        "affiliation": "bad",
        "maxhealth": 40,
        "jobKey": "hero/berserker"
    },
    "#C": {
        "key": "#C",
        "position": {
            "x": 6,
            "y": 3,
            "z": 1
        },
        "affiliation": "bad",
        "maxhealth": 40,
        "jobKey": "hero/berserker"
    },
    "#D": {
        "key": "#D",
        "position": {
            "x": -1,
            "y": 1,
            "z": 1
        },
        "affiliation": "bad",
        "maxhealth": 30,
        "jobKey": "hero/archer"
    }
}
